/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import StopCircle from '@wh/svg-icons/StopCircle';
import PlayCircle from '@wh/svg-icons/PlayCircle';
import Equalizer from './Equalizer';
import './RadioItem.scss';
import { RADIO_RENDERER_TYPE } from '../../../rendererTypes';

// eslint-disable-next-line react/prop-types
const RadioButton = ({ children }) => <button className="radio-item__play-button">{children}</button>;

const RadioItem = ({ active, muted, radio, onEqualizerClick }) => {
  const className = cx('radio-item', { 'radio-item--active': active });
  return (
    <span className={className}>
      <span className="radio-item__label">{radio.label}</span>
      {active ? (
        <span
          className={cx(
            {
              'radio__icon--muted': muted,
            },
            'radio__icon'
          )}
        >
          <Equalizer onClick={onEqualizerClick} />
        </span>
      ) : null}
      {active ? (
        <RadioButton data-test-id={`${RADIO_RENDERER_TYPE}.pause-button`}>
          <StopCircle className="radio-item__icon" />
        </RadioButton>
      ) : (
        <RadioButton data-test-id={`${RADIO_RENDERER_TYPE}.play-button`}>
          <PlayCircle className="radio-item__icon" />
        </RadioButton>
      )}
    </span>
  );
};

RadioItem.propTypes = {
  active: PropTypes.bool,
  muted: PropTypes.bool,
  radio: PropTypes.object,
  onEqualizerClick: PropTypes.func,
};

export default RadioItem;
